module.exports = __webpack_public_path__ + "img/bang3.b0ef81bb.png";